import { requestBuilder } from '../../http/RequestBuilder';
import type {
    EditProposedChangesRequestAction,
    PartialBill,
} from '../types/Bill';

interface BillsApiEditProposedChangesParams {
    membershipId: string;
    billId: string;
}

interface BillsApiEditProposedChangesBody {
    action: EditProposedChangesRequestAction;
    accountId?: string;
    amount?: number;
    cadence?: string;
}

const useEditProposedChanges = requestBuilder.mutation<
    PartialBill,
    BillsApiEditProposedChangesBody,
    BillsApiEditProposedChangesParams
>({
    endpoint: ({ membershipId, billId }) =>
        `/api/holistic-bills/${membershipId}/bill/${billId}/proposed-changes`,
    method: 'POST',
});

export default useEditProposedChanges;
